import { calendar_v3 } from "googleapis";

export function isEventAfterToday(event: calendar_v3.Schema$Event) {
  const startDateString = event.start?.dateTime ?? event.start?.date ?? "";
  if (!startDateString) {
    return false;
  }

  const eventDate = new Date(startDateString);

  // start of tomorrow at midnight
  const startOfTomorrow = new Date();
  startOfTomorrow.setDate(startOfTomorrow.getDate() + 1);
  startOfTomorrow.setHours(0, 0, 0, 0);

  return eventDate > startOfTomorrow;
}
